import { type IReactionDisposer, makeAutoObservable, reaction } from 'mobx'
import { type ITabItem } from 'shared/ui'
import type { IEntitiesStore } from 'entities/EntitiesExport'

type IIntegrationsPageTabKey = 'integrations' | 'automationLogs'

export class IntegrationsPageStore {
  private _activeTabKey: IIntegrationsPageTabKey = 'integrations'
  private _showLogs = false
  private _loading = true

  private _disposeFeatureFlags: IReactionDisposer | null = null

  constructor(private _entities: IEntitiesStore) {
    makeAutoObservable(this)
    this._init()
    this._reactionFeatureFlags()
  }

  get showLogs() {
    return this._showLogs
  }

  get activeTabKey() {
    return this._activeTabKey
  }

  get tabs() {
    const tabs = [
      {
        key: 'integrations',
        name: 'Integrations',
      },
      {
        key: 'automationLogs',
        name: 'Automation Logs',
        statusProps: {
          title: 'New',
          intent: 'purple',
          emphasis: 'high',
          size: 'label',
        },
      },
    ] as ITabItem<IIntegrationsPageTabKey>[]

    return tabs
  }

  get loading() {
    return this._loading
  }

  setActiveTab = (tab: ITabItem<IIntegrationsPageTabKey>) => {
    this._activeTabKey = tab.key
  }
  private _init = () => {
    this._showLogs = this._entities.featureFlagsStore.marketplace_automation_logs
    this._loading = this._entities.featureFlagsStore.loading
  }

  private _reactionFeatureFlags = () => {
    this._disposeFeatureFlags?.()

    this._disposeFeatureFlags = reaction(
      () => [
        this._entities.featureFlagsStore.marketplace_automation_logs,
        this._entities.featureFlagsStore.loading,
      ],
      () => this._init()
    )
  }
}
